const config = {
  domain: 'https://www.bjshuke.com.cn'
};

export default config;